import bodilContrastLogo from '~shared-assets/images/bodil-logo-contrast.png';
import bodilDarkLogo from '~shared-assets/images/bodil-dark.svg';

import { createContext, ReactNode, useContext } from 'react';

import { BodilColor } from '~src/branding';

type BrandingContext = {
  logoURL: string;
  contrastLogoURL: string;
  darkColor: string;
  lightColor: string;
  darkTextColor: string;
  lightTextColor: string;
};

const BASE_BRANDING = {
  logoURL: bodilDarkLogo,
  contrastLogoURL: bodilContrastLogo,
  darkColor: BodilColor.base.default,
  lightColor: BodilColor.ui.action.default,
  darkTextColor: BodilColor.base.default,
  lightTextColor: BodilColor.base.white,
};

const BrandingContext = createContext<BrandingContext>(BASE_BRANDING);

export const BrandingContextProvider = ({ children }: { children?: ReactNode }) => {
  return <BrandingContext.Provider value={BASE_BRANDING}>{children}</BrandingContext.Provider>;
};

export const useBranding = () => useContext<BrandingContext>(BrandingContext);
